function matchWidgetHeightCart(selector) {
  const widgets = document.querySelectorAll(selector);
  if (!widgets.length) return;

  // Reset height
  widgets.forEach(widget => {
    widget.style.height = "auto";
    widget.style.minHeight = "";
    widget.style.display = "block";
  });

  let maxHeight = 0;

  widgets.forEach(widget => {
    maxHeight = Math.max(maxHeight, widget.offsetHeight);
  });

  widgets.forEach(widget => {
    widget.style.minHeight = `${maxHeight}px`;
  });
}

function updateJudgeMeHeightCart() {
  matchWidgetHeightCart(".JJ-collection-product-grid-cro .jdgm-widget");
}

window.addEventListener("load", updateJudgeMeHeightCart);
window.addEventListener("resize", updateJudgeMeHeightCart);